export default {
	defaultProps: {
		fontSize: 'small',
	},
	styleOverrides: {
		root: {
			variants: [
				{
					props: {
						fontSize: 'small',
					},
					style: {
						fontSize: '1rem',
					},
				},
			],
		},
	},
}
